import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    broadbandPage: {
        display: "flex",
        flexDirection: "column",
        backgroundColor: "white",
        minHeight: 600,
        [theme.breakpoints.down("md")]: {
            padding: 0,
        },
    },
}));
